import { InfoCircleOutlined } from "@ant-design/icons";
import styled from "styled-components";

export const StyledInfoCircleOutlined = styled(InfoCircleOutlined)`
    color: ${({ theme }) => theme.dangerTypographyColor};
    font-size: 18px;
`;
